/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomebannerheading2Inputs */

const en_outcomebannerheading2 = /** @type {(inputs: Outcomebannerheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How did it go?`)
};

const pt_outcomebannerheading2 = /** @type {(inputs: Outcomebannerheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como correu?`)
};

/**
* | output |
* | --- |
* | "How did it go?" |
*
* @param {Outcomebannerheading2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomebannerheading2 = /** @type {((inputs?: Outcomebannerheading2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomebannerheading2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomebannerheading2(inputs)
	return pt_outcomebannerheading2(inputs)
});
export { outcomebannerheading2 as "outcomeBannerHeading" }